import { TenantConfig } from '../config/tenant';

interface IdentifierInput {
  prefix?: string;
  pattern?: string;
  date?: Date;
}

const randomDigits = (length: number): string => {
  let out = '';
  for (let i = 0; i < length; i += 1) {
    out += Math.floor(Math.random() * 10).toString();
  }
  return out;
};

export const renderIdentifierPattern = (input: IdentifierInput): string => {
  const date = input.date || new Date();
  const year = date.getFullYear().toString();
  const yy = year.slice(-2);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  const basePattern = (input.pattern || 'YYMMXXXX').toUpperCase();
  const withDateTokens = basePattern
    .replace(/YYYY/g, year)
    .replace(/YY/g, yy)
    .replace(/MM/g, mm)
    .replace(/DD/g, dd);

  const withRandom = withDateTokens.replace(/X{2,12}/g, (token) => randomDigits(token.length));
  return `${(input.prefix || '').trim()}${withRandom}`;
};

export const generateEmployeeId = (tenant: Pick<TenantConfig, 'badgePrefix' | 'identifierPolicy'>): string => {
  return renderIdentifierPattern({
    prefix: tenant.identifierPolicy?.employeePrefix || tenant.badgePrefix,
    pattern: tenant.identifierPolicy?.employeePattern || 'YYMMXXXX',
  });
};

export const generateIncidentNumber = (tenant: Pick<TenantConfig, 'incidentPrefix' | 'identifierPolicy'>): string => {
  return renderIdentifierPattern({
    prefix: tenant.identifierPolicy?.incidentPrefix || tenant.incidentPrefix,
    pattern: tenant.identifierPolicy?.incidentPattern || 'YYYYMMDD-XXXX',
  });
};

export const generateEprNumber = (
  tenant: Pick<TenantConfig, 'incidentPrefix' | 'identifierPolicy'>,
  linkedIncidentNumber?: string
): string => {
  if (tenant.identifierPolicy?.linkEprToIncident !== false && linkedIncidentNumber) {
    return linkedIncidentNumber;
  }

  return renderIdentifierPattern({
    prefix: tenant.identifierPolicy?.eprPrefix || tenant.incidentPrefix,
    pattern: tenant.identifierPolicy?.eprPattern || tenant.identifierPolicy?.incidentPattern || 'YYYYMMDD-XXXX',
  });
};
